import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import NewReleasesIcon from '@mui/icons-material/NewReleases';
import VerifiedIcon from '@mui/icons-material/Verified';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { UfficioContext, UfficioProvider } from './UfficioContext';
import { ContattiList, StoricoList, UfficioDetailsForm } from './components';
import { LinkDialog } from './components/LinkDialog';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack,
        navigateTo,
        getRouteTo,
        compileRoute
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingUfficio,
        getUfficioAsync,

        isUpdatingUfficio,
        updateUfficioAsync,

        isAddingUfficio,
        addUfficioAsync,

        isLoadingTipi,
        getTipiAsync,

        isLoadingComuni,
        getComuniAsync,

        isLoadingUffici,
        getUfficiAsync,

        isDeletingContatto,
        deleteContattoAsync,

        isLoadingStorici,
        getStoriciAsync,

        lockUfficioAsync,
        unlockUfficioAsync,

        setPristine,
        setDirty,
        Prompt
    } = useContext(UfficioContext)

    const {
        ufficio,
    } = state;

    const {
        ufficioId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }
    const [isLinkDialogOpen, setIsLinkDialogOpen] = useState(false);
    const linkClickHandler = () => {
        setIsLinkDialogOpen(true);
    }

    const cancelClickHandler = () => {
        navigateTo(compileRoute(NavRoutes.Ufficio, [ufficioId]) + "?solaLettura=true");
        unlockUfficioAsync(ufficio.id, false, true, true)
        // window.close();
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingUfficio || isUpdatingUfficio || isAddingUfficio || isDeletingContatto || isLoadingStorici);
    }, [isLoadingUfficio, isUpdatingUfficio, isAddingUfficio, isDeletingContatto, isLoadingStorici]);

    const ufficioDetailsFormActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (ufficio) {
                    await updateUfficioAsync(ufficioId, data);
                } else {
                    await addUfficioAsync(data);
                }
                break;
            default:
                break;
        }
    }

    const contattiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(getRouteTo(NavRoutes.ContattoAdd, [ufficio.id]), "_blank").focus()
                break;
            case "Delete":
                await deleteContattoAsync(data.ufficioId, data.id);
                break;
            case "Wizard":
                navigateTo(NavRoutes.ContattiWizard, [ufficio.id])
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (ufficio && user) {
            addBreadcrumbToken(ufficio.nome);
            getTipiAsync();
            getComuniAsync(ufficio.comune.denominazioneIt, true);
            getUfficiAsync(ufficio.zonaRiferimento);
            getStoriciAsync(ufficioId);
            getUfficiAsync();
        }
    }, [ufficio, user]);

    useEffect(() => {
        if (user) {
            if (!ufficioId) {
                addBreadcrumbToken("Aggiungi");
                getTipiAsync();
                getComuniAsync(null, true);
                getUfficiAsync();
            }
            else {
                if (ufficioId) {
                    if (!solaLettura) {
                        lockUfficioAsync(ufficioId);
                        // setDirty();
                    }

                    getUfficioAsync(ufficioId);
                    // if (solaLettura && user.ruoloId === 3)
                    //     getLockedEntityAsync(interrogazioneId)
                }
            }
        }
    }, [user]);

    if (!user)
        return <Container>
            <LinearProgress />
        </Container>

    const urlParams = new URLSearchParams(window.location.search);
    const solaLettura = /^true$/i.test(urlParams.get("solaLettura"));

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            disabled={isLoading || solaLettura}
                            save
                            onSaveClick={saveClickHandler}
                            title={
                                <>
                                    {
                                        `Ufficio "${ufficio?.nome ?? ""}"`
                                    }
                                    {
                                        ufficio?.convalidato ?
                                            <VerifiedIcon color="success" />
                                            :
                                            <NewReleasesIcon color="warning" />
                                    }
                                </>
                            }
                            custom
                            customText={`LINK`}
                            onCustomClick={linkClickHandler}
                            cancel
                            cancelText={`ANNULLA`}
                            onCancelClick={cancelClickHandler}
                            subtitle="Gestisci l'ufficio" />
                    </Grid>
                    <Grid item xs={12}>
                        <UfficioDetailsForm
                            onActionClick={ufficioDetailsFormActionClickHandler}
                            disabled={isLoading}
                            formRef={formRef} />
                    </Grid>
                    {ufficio &&
                        <Grid item xs={12}>
                            <ContattiList
                                disabled={isLoading}
                                onActionClick={contattiListActionClickHandler}
                            />
                        </Grid>
                    }
                    {ufficio &&
                        <Grid item xs={12}>
                            <StoricoList
                                disabled={isLoading} />
                        </Grid>
                    }
                    {isLinkDialogOpen &&
                        <Grid item xs={12}>
                            <LinkDialog
                                isOpen={isLinkDialogOpen}
                                disabled={isLoading}
                                handleClose={() => setIsLinkDialogOpen(false)} />
                        </Grid>
                    }
                </Grid>
            </Container>
        </>
    );
}

export const UfficioPage = () => {

    return (
        <UfficioProvider>
            <PageContent />
        </UfficioProvider>
    );
}